import styled from 'foundations-theming/utils';
import UIFlex from 'UIComponents/layout/UIFlex';
import Big from 'UIComponents/elements/Big';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ReadabilityIssueCategories } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCardWrapper = styled.div.withConfig({
  displayName: "ReadabilityIssuesCardList__StyledCardWrapper",
  componentId: "sc-14ibf0k-0"
})(["border:1px solid ", ";margin-bottom:5px;padding:10px 20px;"], ({
  theme
}) => theme.color['do-not-use-button-tertiary-light-hover-fill']);
const StyledBulletPointWrapper = styled.div.withConfig({
  displayName: "ReadabilityIssuesCardList__StyledBulletPointWrapper",
  componentId: "sc-14ibf0k-1"
})(["text-align:center;color:", ";margin-right:10px;"], ({
  theme
}) => theme.color['do-not-use-linkedin']);
const StyledBoldedText = styled.span.withConfig({
  displayName: "ReadabilityIssuesCardList__StyledBoldedText",
  componentId: "sc-14ibf0k-2"
})(["font-weight:500;margin-right:8px;"]);
const IssueCategorySubHeader = ({
  category
}) => {
  switch (category) {
    case ReadabilityIssueCategories.GRAMMAR:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.readabilityRecs.categories.GRAMMAR"
      });
    default:
      console.error(`No readability category translation found for ${category}`);
      return null;
  }
};
export const ReadabilityIssuesCardList = ({
  issues
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "m-left-6 m-bottom-2",
    children: issues.map((issue, index) => {
      const {
        category,
        text,
        suggestions
      } = issue;
      if (suggestions.length === 0) {
        return null;
      }
      return /*#__PURE__*/_jsx(StyledCardWrapper, {
        children: /*#__PURE__*/_jsxs(UIFlex, {
          direction: "row",
          align: "baseline",
          children: [/*#__PURE__*/_jsx(StyledBulletPointWrapper, {
            children: /*#__PURE__*/_jsx(Big, {
              weight: "medium",
              children: "\u2022"
            })
          }), /*#__PURE__*/_jsx(StyledBoldedText, {
            children: text
          }), /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(IssueCategorySubHeader, {
              category: category
            }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.recommendations.readabilityRecs.errorText"
            })]
          })]
        })
      }, index);
    })
  });
};